import * as angular from 'angular';

import { connectionPointTypes } from '../../../../common';
import { ConnectionPointType, ComponentDefinition, ConnectionPoint, ConnectionPointTestResult, ConnectionPointStatus, ConnectionPointViewModel } from '../../../../models';
import { IWideDatabaseService } from '../../../../services';


const warning = { panel: { class: 'panel-warning', icon: 'fa-exclamation-triangle' }, icon: 'fa-exclamation-triangle warning' };
const error = { panel: { class: 'panel-danger', icon: 'fa-exclamation-circle' }, icon: 'fa-remove error' };

const statusDisplayDic: { [status: number]: { panel: { class: string, icon: string }, icon: string } } = {
    0: { panel: { class: null, icon: null }, icon: 'fa-check success' },
    100: { panel: { class: 'panel-info', icon: null }, icon: '' },
    200: warning,
    250: warning,
    300: error,
    400: error,
    500: error,
    550: warning,
    600: { panel: { class: 'panel-danger', icon: 'fa-exclamation-circle' }, icon: 'fa-question error' },
};

class ConnectionPointController implements angular.IComponentController {

    isAvailable: boolean;
    isLoading: boolean;
    isUpToDate: boolean;
    loadingMessage: string;

    readonly isStatusLoading: boolean;
    readonly model: ConnectionPoint;
    readonly status: ConnectionPointTestResult;
    readonly viewModel: ConnectionPointViewModel;

    private _wideDbTypes: string[];

    static $inject = ['$q', 'wideDatabaseService'];
    constructor(
        private _$q: angular.IQService,
        private _wideDatabaseService: IWideDatabaseService
    ) {
        this._wideDbTypes = connectionPointTypes
            .filter(c => c.key === ConnectionPointType.WideDatabase || c.key === ConnectionPointType.WideDatabaseNpgsql)
            .map(c => c.value);
    }

    $onInit() {
        if (this.viewModel && this.viewModel.isValid && !this.model.creating) {
            this.isLoading = this.isStatusLoading;
            this.loadingMessage = 'Testing';
            if (this.status) {
                this.updateVmWithStatus();
            }
        }
    }

    $onChanges(changes: angular.IOnChangesObject) {
        this.isLoading = this.isStatusLoading;
        if (this.status) {
            this.updateVmWithStatus();
        }
    }

    private updateVmWithStatus() {
        this.isLoading = this.isLoading || this.status.isLoading;
        this.updateViewModelAccordingStatus()
            .then(result => this.viewModel.isUpToDate = result);
    }

    private updateViewModelAccordingStatus(): angular.IPromise<boolean> {
        let message = this.status?.message;
        if (this.status?.status === ConnectionPointStatus.SmtpProblem) {
            message = 'Testing user credentials on SMTP server failed. Sending emails might however actually work.';
        }
        if (!message && this.status?.status === ConnectionPointStatus.NotAvailable) {
            message = 'Access is denied. Check address, DB name and credentials.';
        }
        if (!message && this.status?.status === ConnectionPointStatus.Deprecated) {
            message = 'PI SDK will be deprecated in the future. Consider using PI AF instead';
        }
        this.viewModel.status = {
            iconClass: statusDisplayDic[this.status.status].icon,
            panel: statusDisplayDic[this.status.status].panel,
            message: message,
            messageParams: {
                type: ConnectionPointType[this.model.type]
            }
        };

        const availableStatuses = [
            ConnectionPointStatus.OK,
            ConnectionPointStatus.Desynchronized,
            ConnectionPointStatus.Deprecated
        ];

        this.viewModel.isAvailable = this.status
            && availableStatuses.indexOf(this.status.status) >= 0;

        this.viewModel.secondDifference = this.status.timeDifferenceInSecond !== 0
            ? this.status.timeDifferenceInSecond
            : null;
        if (this.viewModel.isAvailable) {
            if (this._wideDbTypes.indexOf(this.viewModel.connectionPointType) >= 0) {
                this.loadingMessage = 'Checking database';
                // TODO this should not be checked on every refresh.
                // It may be in future returned by connection point test
                // and not be required directly in tile.
                return this._wideDatabaseService.isUpToDate(this.viewModel.guid);
            } else {
                return this._$q.resolve<boolean>(true);
            }
        } else {
            return this._$q.resolve<boolean>(true);
        }
    }
}

export const wtConnectionPoint: ComponentDefinition = {
    componentId: 'wtConnectionPoint',
    controller: ConnectionPointController,
    template: require('./connectionPoint.component.html'),
    controllerAs: 'vm',
    bindings: {
        isStatusLoading: '<',
        model: '<?',
        status: '<?',
        viewModel: '<',
    }
};
